export const getLoader = state => state.loader.loading;


// WEBPACK FOOTER //
// ./src/store/getters.js